// extracted by mini-css-extract-plugin
export var closeButton = "_hc-2";
export var closeButtonIcon = "_hc-3";
export var lightboxContent = "_hc-1";
export var lightboxOverlay = "_hc-0";